<template>
	<div id="customToolbar" class="e-control e-toolbar e-lib e-keyboard">
		<div class="e-toolbar-items e-tbar-pos">
			<div class="e-toolbar-left">
				<div v-if="isLawDepot" class="e-toolbar-item LawDepot">
					<span class="icon" />
				</div>
				<div class="e-toolbar-item documents e-icons">
					<document-select
						:selected-document-id="selectedDocumentId"
						:documents="documents"
						@update:selectedDocumentId="$emit(`update:selectedDocumentId`, $event)"
					/>
				</div>

				<div
					class="e-toolbar-item next"
					title="Previous"
					@click="pdfViewer?.value?.navigation?.goToPreviousPage()"
				>
					<button class="e-tbar-btn e-control e-btn e-lib e-icon-btn">
						<span class="next-page e-icons" />
					</button>
				</div>
				<div
					class="e-toolbar-item previous"
					title="Next"
					@click="pdfViewer?.value?.navigation?.goToNextPage()"
				>
					<button class="e-tbar-btn e-control e-btn e-lib e-icon-btn">
						<span class="previous-page e-icons" />
					</button>
				</div>
				<div
					class="e-toolbar-item"
					title="Zoom out"
					@click="pdfViewer?.value?.magnification?.zoomOut()"
				>
					<button class="e-tbar-btn e-control e-btn e-lib e-icon-btn">
						<span class="zoom-out e-icons" />
					</button>
				</div>
				<div
					class="e-toolbar-item zoom-in"
					title="Zoom in"
					@click="pdfViewer?.value?.magnification?.zoomIn()"
				>
					<button class="e-tbar-btn e-control e-btn e-lib e-icon-btn">
						<span class="zoom-in e-icons" />
					</button>
				</div>
				<div v-if="!isLawDepot" class="e-toolbar-item hand">
					<button
						class="e-tbar-btn e-control e-btn e-lib e-icon-btn"
						@click="$emit(`update:isPanMode`, true)"
					>
						<span :class="['hand', 'e-icons', { 'selected': isPanMode }]" />
					</button>
				</div>
				<div v-if="!isLawDepot" class="e-toolbar-item pointer">
					<button
						class="e-tbar-btn e-control e-btn e-lib e-icon-btn"
						@click="$emit(`update:isPanMode`, false)"
					>
						<span :class="['pointer', 'e-icons', { 'selected': !isPanMode }]" />
					</button>
				</div>
				<slot />
			</div>
			<div class="e-toolbar-right">
				<div
					class="e-toolbar-item e-tbtn-align camera"
					:class="{ 'e-overlay': isCameraTab }"
					title="Page camera"
					@click="cameraClicked"
				>
					<button class="e-btn">
						<span class="icon" />
					</button>
				</div>
				<div
					v-if="hasEditingTab"
					class="e-toolbar-item e-tbtn-align editing"
					:class="{ 'e-overlay': isEditingTab }"
					title="Page editing"
					@click="editingClicked"
				>
					<button class="e-btn">
						<span class="icon" />
					</button>
				</div>
				<div
					v-if="!isMobileUA()"
					class="e-toolbar-item e-tbtn-align thumbnails"
					:class="{ 'e-overlay': isThumbnailsTab }"
					title="Page thumbnails"
					@click="thumbnailsClicked"
				>
					<button class="e-btn">
						<span class="icon" />
					</button>
				</div>
				<div class="mobileSignersButton" />
			</div>
		</div>
	</div>
</template>

<script>
import DocumentSelect from "./DocumentSelect.vue";
import { useCallTabs } from "../../composables/callTabs.js";
import { isMobileUA } from "../../helpers/mobile.js";
import TABS from "../../models/tabs.js";
import { toRef } from "vue";

export default {
	components: { DocumentSelect },
	inject: {
		pdfViewer: { type: Object },
	},
	props: {
		selectedDocumentId: { type: Number, required: true },
		documents: { type: Array, required: true },
		isPanMode: { type: Boolean, required: true },
		hasEditingTab: { type: Boolean, default: false },
		currentTab: { type: String, required: true },
		isLawDepot: { type: Boolean, default: true },
	},
	emits: [`update:selectedDocumentId`, `update:currentTab`, `update:isPanMode`],
	setup(props) {
		const currentTab = toRef(props, `currentTab`);
		const { isCameraTab, isEditingTab, isThumbnailsTab } = useCallTabs(currentTab);

		return {
			isCameraTab,
			isEditingTab,
			isThumbnailsTab	
		};
	},
	methods: {
		thumbnailsClicked() {
			this.$emit(`update:currentTab`, TABS.THUMBNAILS);
		},
		editingClicked() {
			this.$emit(`update:currentTab`, TABS.EDITING);
		},
		cameraClicked() {
			this.$emit(`update:currentTab`, TABS.CAMERA);
		},
		isMobileUA
	},
};
</script>